import React, { useState, useMemo, useCallback, useEffect } from 'react';

import './CircleToggle.styles.scss';

const CircleToggle = ({ checked, forceUseProp, id, disabled, readOnly, onChange }) => {
    const [checkedState, setCheckedState] = useState(checked);

    const checkedValue = useMemo(() => {
        if (forceUseProp) {
            return checked;
        }

        return checkedState;
    }, [forceUseProp, checked, checkedState]);

    const change = useCallback(nextChecked => {
        if (checkedValue === nextChecked) {
            return;
        }

        setCheckedState(nextChecked);
        onChange && onChange(nextChecked);
    }, [checkedValue, setCheckedState, onChange]);

    const handleClick = useCallback(() => {
        if (disabled || readOnly) {
            return;
        }

        change(!checkedValue)
    }, [disabled, readOnly, checkedValue, change]);

    const handleChange = useCallback(event => {
        change(event.target.checked);
    }, [change]);

    useEffect(() => {
        setCheckedState(checked);
    }, [checked]);

    return (
        <span className={'circle-toggle' + (checkedValue ? ' checked' : '') + (disabled ? ' disabled' : '')} onClick={handleClick}>
            {
                id ? <input type="checkbox" id={id} disabled={disabled} checked={checkedValue} onChange={handleChange} /> : null
            }
        </span>
    )
}

export default CircleToggle;
